export enum SenderType {
    system = 1,
    provider = 2,
    auction = 3,
}
